
{
  "userMenu": {
    "profile": "个人资料",
    "myListings": "我的列表",
    "myFavorites": "我的收藏",
    "referFriend": "推荐朋友"
  },
  "profile": {
    "title": "个人资料设置",
    "personalInfo": "个人信息",
    "accountSettings": "账户设置",
    "referral": {
      "title": "推荐朋友",
      "description": "分享您的推荐链接，当朋友注册时获得奖励",
      "copy": "复制链接",
      "copiedSuccess": "推荐链接已复制！",
      "copiedDescription": "与您的朋友分享此链接",
      "referViaWhatsapp": "通过WhatsApp推荐"
    }
  },
  "listings": {
    "title": "我的列表",
    "empty": {
      "title": "尚无列表",
      "description": "创建您的第一个列表以开始吸引客户",
      "cta": "创建列表"
    },
    "status": {
      "pending": "待审核",
      "approved": "已启用",
      "rejected": "已拒绝"
    }
  },
  "favorites": {
    "title": "我的收藏",
    "empty": {
      "title": "尚无收藏",
      "description": "保存您感兴趣的服务提供者",
      "cta": "浏览服务"
    }
  },
  "analytics": {
    "title": "分析",
    "views": "浏览次数",
    "contacts": "联系次数",
    "performance": "表现"
  }
}
